module.exports = __webpack_public_path__ + "img/bg_not_data.0f62dd6e.png";